<template>
  <v-app>
    <app-main />
    <app-bottom />
  </v-app>
</template>

<script>
import AppMain from "./layout/AppMain";
import AppBottom from "./layout/AppBottom";

export default {
  name: "App",
  components: {
    AppMain,
    AppBottom
  },
  data: () => ({
    drawer: false,
    isSmallScreen: false,
    isIconClicked: false
  }),
  methods: {
    showSidebar() {
      this.isIconClicked = !this.isIconClicked;
    }
  }
};
</script>
